import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterDistrictSearch = () => {
  const districtSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-district/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { districtSearch }
}

export default InteractorMasterDistrictSearch
